<template>
	<div class="university-evaluation-page">
		<Head />
		<main class="uni-main">
			<section class="hero-section section-py">
				<div class="container-custom hero-grid">
					<div class="fade-in">
						<div class="hero-badge">大学心理健康 · 闭环管理</div>
						<h1>大学心理测评实施方案</h1>
						<p class="hero-tagline">科学测评 · 分级预警 · 精准干预 · 守护成长</p>
						<!-- <p class="hero-meta">
							主办单位：学生工作处 · 心理健康教育中心<br>
							<span class="hero-date">XXXX年XX月</span>
						</p> -->
					</div>
					<div class="hero-image-wrap fade-in">
						<img src="https://picsum.photos/900/560?random=71" alt="大学心理测评与心理健康教育">
					</div>
				</div>
			</section>
			<section id="general-rules" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						
						<h2>方案总则 — 测评目的</h2>
						<div class="title-underline"></div>
						<p>科学测评 · 守护心灵 — 构建全方位心理健康监测体系，为校园安全保驾护航</p>
					</div>
					<div class="highlight-card card card-hover">
						<div class="goal-grid-lite">
							<div class="goal-mini">
								<div class="goal-mini-title">数据支撑</div>
								<p>全面掌握学生心理健康状况，建立完善心理档案，为心理健康教育工作提供科学依据。</p>
							</div>
							<div class="goal-mini">
								<div class="goal-mini-title">危机防控</div>
								<p>精准筛查心理困扰学生，科学划分预警等级，筑牢校园心理安全防线，杜绝极端事件。</p>
							</div>
							<div class="goal-mini">
								<div class="goal-mini-title">自我认知</div>
								<p>帮助学生正视心理状态，提升自我调适能力，树立积极健康的心理观念。</p>
							</div>
							<div class="goal-mini">
								<div class="goal-mini-title">精准施教</div>
								<p>为分层分类开展心理课程、团体辅导、个体咨询提供方向，提升工作实效性。</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="principles" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						
						<h2>心理健康测评工作方案总则：测评原则与对象</h2>
						<div class="title-underline"></div>
					</div>
					<div class="two-grid">
						<div class="card card-hover soft-glow">
							<h3 class="gradient-text">测评原则</h3>
							<ul class="desc-list compact">
								<li><strong>科学性原则：</strong>标准化量表，专业流程，结果客观精准</li>
								<li><strong>保密性原则：</strong>严守学生隐私，严控信息传播，切实保障权益。</li>
								<li><strong>全员参与原则：</strong>全覆盖无遗漏，针对特殊情况进行报备补测。</li>
								<li><strong>教育性原则：</strong>测评结合科普教育，有效疏解学生抵触情绪。</li>
								<li><strong>实效性原则：</strong>杜绝形式化，实行分级干预，切实解决问题。</li>
							</ul>
						</div>
						<div class="card card-hover soft-glow">
							<h3 class="gradient-text">测评对象</h3>
							<p class="lead">全体在校本科生、研究生</p>
							<ul class="desc-list compact">
								<li><strong>新生群体：</strong>入学1个月内完成首次测评</li>
								<li><strong>非新生群体：</strong>每学年秋季学期完成年度测评</li>
								<li><strong>毕业群体：</strong>毕业前追加专项心理测评</li>
								<li><strong>重点关注群体：</strong>按需开展专项补测</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="org-lead" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						
						<h2>测评组织架构与职责分工 — 领导小组</h2>
						<div class="title-underline"></div>
					</div>
					<div class="two-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">领导小组核心构成</h3>
							<div class="stack-item">
								<h4>组长</h4>
								<p>分管学生工作副校长</p>
							</div>
							<div class="stack-item">
								<h4>成员</h4>
								<p>学工处、教务处、研究生院、保卫处、各学院副书记、心理中心负责人</p>
							</div>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">核心职责</h3>
							<div class="responsibility-pills">
								<div class="pill-item"><strong>统筹全局：</strong>把握测评工作整体方向与节奏</div>
								<div class="pill-item"><strong>审批方案：</strong>审定实施细则与流程规范</div>
								<div class="pill-item"><strong>协调资源：</strong>调配人财物及场地资源</div>
								<div class="pill-item"><strong>监督落实：</strong>跟踪进度，确保落地见效</div>
								<div class="pill-item"><strong>危机干预：</strong>审批高等级危机干预专项方案</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="org-exec" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>测评组织架构与职责分工 — 执行与配合</h2>
						<div class="title-underline"></div>
						<p>职责明确 · 协同高效 · 保障有力</p>
					</div>
					<div class="card-box">
						<div class="card card-hover exec-card" style="width: 100%;">
							<h3 class="gradient-text">执行小组：核心落地与实施</h3>
							<p><strong>组长：</strong>心理中心主任</p>
							<p><strong>成员：</strong>专职心理教师、学院心理辅导员、班级心理委员</p>
							<p class="exec-duty">
								<strong>职责：</strong>方案落地、测评实施、数据处理、预警判定、档案建立、干预落实、人员培训
							</p>
						</div>
						<div class="card card-hover card-right" style="width: 100%;">
							<h3 class="gradient-text">配合部门：多方协同与保障</h3>
							<ul class="desc-list">
								<li><strong>各学院：</strong>组织测评、约谈帮扶、思想引导、状态反馈</li>
								<li><strong>教务处：</strong>协调时间、保障场地、纳入新生入学教育</li>
								<li><strong>信息技术中心：</strong>技术支持、系统运维、数据安全</li>
								<li><strong>保卫处：</strong>危机现场处置、测评秩序维护</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
			<section id="tools-basic" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>测评工具选择：通用基础测评（全员必测）</h2>
						<div class="title-underline"></div>
						<p>科学选表 · 精准筛查 · 客观评估</p>
					</div>
					<div class="tool-grid">
						<div v-for="t in toolsBasic" :key="t.name" class="card card-hover tool-card">
							<h4>{{ t.name }}</h4>
							<p>{{ t.desc }}</p>
						</div>
					</div>
				</div>
			</section>
			<section id="tools-extra" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>专项特色测评（按需选测）</h2>
						<div class="title-underline"></div>
						<p>按需施测 · 精准画像 · 快速响应 · 闭环干预</p>
					</div>
					<ul class="bullet-list card card-hover">
						<li v-for="line in toolsExtra" :key="line">{{ line }}</li>
					</ul>
				</div>
			</section>

			<section id="warning-levels" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>心理危机预警等级划分（四级体系）</h2>
						<div class="title-underline"></div>
						<p>精准施策 · 分级管控 — 建立「早发现、早报告、早评估、早干预」闭环</p>
					</div>
					<div class="level-grid">
						<div class="level-card level-red card-hover">
							<h4>红色 · 三级预警</h4>
							<p>重度心理危机 → 立即干预，24h 监护</p>
						</div>
						<div class="level-card level-yellow card-hover">
							<h4>黄色 · 二级预警</h4>
							<p>中度心理困扰 → 重点关注，定期约谈</p>
						</div>
						<div class="level-card level-blue card-hover">
							<h4>蓝色 · 一级预警</h4>
							<p>轻度心理困扰 → 一般关注，团体辅导</p>
						</div>
						<div class="level-card level-green card-hover">
							<h4>绿色 · 无预警</h4>
							<p>正常健康状态 → 常态化心理健康普及</p>
						</div>
					</div>
				</div>
			</section>
			<section id="handle-gb" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>预警等级及处置 — 绿色 · 蓝色</h2>
						<div class="title-underline"></div>
						<p>早发现 · 早干预 · 早治疗</p>
					</div>
					<div class="two-grid">
						<div class="card card-hover border-green">
							<h3 class="gradient-text">绿色：无预警 · 正常健康</h3>
							<p><strong>界定标准：</strong>量表得分正常，情绪稳定，适应良好，无自伤自杀意念。</p>
							<p><strong>干预主体：</strong>心理中心、学院辅导员</p>
							<p><strong>核心措施：</strong>常规心理教育，年度跟踪，建立基础档案</p>
						</div>
						<div class="card card-hover border-blue">
							<h3 class="gradient-text">蓝色：一级预警 · 轻度困扰</h3>
							<p><strong>界定标准：</strong>个别量表轻度超标，轻微情绪波动、适应不良、学业压力，可自主调节。</p>
							<p><strong>干预主体：</strong>学院心理辅导员、心理委员</p>
							<p><strong>核心措施：</strong>谈心谈话、自助引导、团体辅导，每月跟踪，学院留存记录。</p>
						</div>
					</div>
				</div>
			</section>
			<section id="handle-yr" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>预警等级及处置 — 黄色 · 红色</h2>
						<div class="title-underline"></div>
					</div>
					<div class="two-grid">
						<div class="card card-hover border-yellow">
							<h3 class="gradient-text">黄色预警 · 二级（中度困扰）</h3>
							<p><strong>界定标准：</strong>明显抑郁焦虑，情绪调节困难，偶有消极想法（无自杀计划）</p>
							<p><strong>干预主体：</strong>专职心理教师、学院辅导员</p>
							<p><strong>核心措施：</strong>中心备案，每周个体咨询，家校联动，双周评估并动态调整</p>
						</div>
						<div class="card card-hover border-red">
							<h3 class="gradient-text">红色预警 · 三级（重度危机）</h3>
							<p><strong>界定标准：</strong>量表严重超标，有明确自杀意念/计划/自伤行为，无法正常学习生活。</p>
							<p><strong>干预主体：</strong>心理中心、学工处、学院、家长、医疗机构</p>
							<p><strong>核心措施：</strong>立即启动预案，24小时联系家长，专人陪护，就医治疗，复学后长期跟踪。</p>
						</div>
					</div>
				</div>
			</section>

			<section id="flow-new" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>分群体测评流程 — 新生入学测评</h2>
						<div class="title-underline"></div>
						<p>入学1个月内完成 — 精准摸排 · 及时干预 · 守护新生</p>
					</div>
					<div class="phase-list card card-hover">
						<div v-for="(step, i) in flowNewStudent" :key="step.title" class="phase-item">
							<span>{{ `0${i + 1}`.slice(-2) }}</span>
							<div>
								<h4>{{ step.title }}</h4>
								<p>{{ step.meta }} → {{ step.work }}</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="flow-returning" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>分群体测评流程 — 非新生年度测评</h2>
						<div class="title-underline"></div>
						<p>每学年9–10月 — 常态化心理跟踪机制，全周期精准帮扶</p>
					</div>
					<div class="phase-list card card-hover">
						<div v-for="(step, i) in flowReturning" :key="step.title" class="phase-item">
							<span>{{ `0${i + 1}`.slice(-2) }}</span>
							<div>
								<h4>{{ step.title }}</h4>
								<p>{{ step.meta }} → {{ step.work }}</p>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="result-use" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>测评结果应用与干预措施</h2>
						<div class="title-underline"></div>
					</div>
					<div class="three-grid">
						<div class="card card-hover">
							<h3 class="gradient-text">整体结果应用</h3>
							<ul class="desc-list">
								<li>形成年度心理健康分析报告，辅助决策</li>
								<li>针对共性问题开展讲座与团体辅导</li>
							</ul>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">个体分级干预</h3>
							<ul class="desc-list">
								<li>落实四级预警，构建校-院-班-舍防控网</li>
								<li>结果不挂钩评优、评奖、入党、就业</li>
							</ul>
						</div>
						<div class="card card-hover">
							<h3 class="gradient-text">家校协同干预</h3>
							<ul class="desc-list">
								<li>重点预警学生及时同步家长，客观反馈</li>
								<li>定期沟通，建立家校共育帮扶机制</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<section id="confidential" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>保密制度与伦理规范</h2>
						<div class="title-underline"></div>
					</div>
					<ul class="bullet-list card card-hover">
						<li><strong>全员保密承诺：</strong>所有工作人员签订保密协议，严禁泄露信息</li>
						<li><strong>档案管理规范：</strong>专属心理档案，专人保管，实名登记查阅</li>
						<li><strong>数据使用规范：</strong>仅用于心理教育与危机干预，加密存储</li>
						<li><strong>学生权益保障：</strong>尊重复核权利，严禁强迫测评</li>
					</ul>
				</div>
			</section>

			<section id="safeguard" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>保障措施</h2>
						<div class="title-underline"></div>
						<p>全方位保障体系，筑牢心理健康防线</p>
					</div>
					<div class="two-grid">
						<ul class="bullet-list card card-hover">
							<li><strong>人员保障：</strong>专职+兼职团队，定期培训，四级防控网络</li>
							<li><strong>技术与物资保障：</strong>系统稳定运维，数据安全，纸质量表与咨询场地</li>
						</ul>
						<ul class="bullet-list card card-hover">
							<li><strong>经费保障：</strong>专项经费，专款专用，保障量表、运维、干预支出</li>
							<li><strong>制度保障：</strong>完善测评、预警、档案、保密制度，纳入年度考核</li>
						</ul>
					</div>
				</div>
			</section>

			<section id="emergency" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>应急预案与突发情况处置机制</h2>
						<div class="title-underline"></div>
					</div>
					<ul class="number-plain card card-hover">
						<li v-for="(e, i) in emergencyItems" :key="i"><strong>{{ e.title }}</strong>{{ e.text }}</li>
					</ul>
				</div>
			</section>

			<section id="schedule" class="section-py section-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>工作推进计划表</h2>
						<div class="title-underline"></div>
					</div>
					<div class="table-wrap card card-hover">
						<table class="plan-table">
							<thead>
								<tr>
									<th>测评群体</th>
									<th>阶段</th>
									<th>时间节点</th>
									<th>核心工作</th>
									<th>负责部门</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(row, i) in planRows" :key="i">
									<td>{{ row.group }}</td>
									<td>{{ row.phase }}</td>
									<td>{{ row.time }}</td>
									<td>{{ row.work }}</td>
									<td>{{ row.dept }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</section>

			<section id="summary" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>方案总结与优化</h2>
						<div class="title-underline"></div>
						<p>守护学生心理健康 · 构建闭环工作机制</p>
					</div>
					<ul class="bullet-list card card-hover">
						<li><strong>年度总结：</strong>每学年结束后全面复盘实施、预警、干预效果</li>
						<li><strong>经验梳理：</strong>总结亮点，梳理短板，明确问题不足</li>
						<li><strong>持续优化：</strong>优化问卷、流程、预警标准、干预措施</li>
						<li><strong>长效推进：</strong>构建「测评-筛查-干预-跟踪-优化」闭环</li>
					</ul>
				</div>
			</section>
			<SiteFooter />
		</main>
	</div>
</template>

<script>
	import Head from '@/components/head/index.vue'
	import SiteFooter from '@/components/footer/index.vue'

	export default {
		name: 'UniversityEvaluation',
		components: {
			Head,
			SiteFooter
		},
		data() {
			return {
				tocItems: [{
						num: '01',
						id: 'general-rules',
						title: '方案总则'
					},
					{
						num: '02',
						id: 'org-lead',
						title: '组织架构与职责'
					},
					{
						num: '03',
						id: 'tools-basic',
						title: '测评内容与工具'
					},
					{
						num: '04',
						id: 'warning-levels',
						title: '危机预警与处置'
					},
					{
						num: '05',
						id: 'flow-new',
						title: '分群体实施流程'
					},
					{
						num: '06',
						id: 'result-use',
						title: '结果应用与干预'
					},
					{
						num: '07',
						id: 'confidential',
						title: '保密制度与保障'
					},
					{
						num: '08',
						id: 'emergency',
						title: '应急预案与进度'
					},
					{
						num: '09',
						id: 'summary',
						title: '总结与持续优化'
					}
				],
				toolsBasic: [{
						name: '90项症状清单（SCL-90）',
						desc: '筛查躯体化、强迫、人际敏感等9类心理症状，为预警划分提供核心依据'
					},
					{
						name: '大学生人格问卷（UPI）',
						desc: '新生专属量表，快速筛查适应障碍、神经症倾向、自杀意念及既往病史'
					},
					{
						name: '抑郁自评量表（SDS）',
						desc: '科学评估抑郁情绪状态与严重程度，辅助危机预警'
					},
					{
						name: '焦虑自评量表（SAS）',
						desc: '评估当前焦虑水平，快速筛查高焦虑风险学生'
					}
				],
				toolsExtra: [
					'成人依恋量表（AAS）：评估人际关系与亲密关系模式',
					'学习适应性量表：聚焦学业压力源与适应能力评估',
					'自杀风险评估量表：专项排查高危学生，直接纳入高预警',
					'压力应对方式量表：解析压力应对策略，为辅导提供依据'
				],
				flowNewStudent: [{
						title: '前期筹备',
						meta: '报到前1周–后3天',
						work: '方案制定，账号创建，宣讲培训，指南发放'
					},
					{
						title: '集中测评',
						meta: '报到后3–7天',
						work: '班级集中作答，机房/教室线上，全程监督管理，确保真实有效'
					},
					{
						title: '补测复核',
						meta: '报到后7–10天',
						work: '漏测人员补测，无效数据筛查，人工复核确认，确保全员覆盖'
					},
					{
						title: '等级筛查',
						meta: '补测后3–5天',
						work: '数据智能核算,心理预警分级,高危学生复评,制定干预方案'
					},
					{
						title: '建档干预',
						meta: '筛查后持续',
						work: '建立心理档案,实施分级干预,1个月后回访,动态跟踪调整'
					}
				],
				flowReturning: [{
						title: '通知动员',
						meta: '9月上旬',
						work: '发布正式通知,开展班会宣讲,消除学生抵触情绪'
					},
					{
						title: '分批测评',
						meta: '9月中下旬',
						work: '线上自主测评，7天内完成'
					},
					{
						title: '数据核查',
						meta: '10月上旬',
						work: '清洗无效数据、统一补测'
					},
					{
						title: '等级更新',
						meta: '10月中旬',
						work: '结合历年档案，重新核定预警'
					},
					{
						title: '跟踪干预',
						meta: '全年常态化',
						work: '分级帮扶、学期回访、专项排查'
					}
				],
				emergencyItems: [{
						title: '技术故障：',
						text: '系统崩溃立即暂停，启动纸质量表备用'
					},
					{
						title: '突发心理危机：',
						text: '遇情绪失控、自伤倾向，立即启动红色预警'
					},
					{
						title: '数据泄露：',
						text: '立即封存数据，溯源排查，上报领导小组'
					},
					{
						title: '拒测行为：',
						text: '耐心疏导，严禁强迫；异常者纳入黄色预警'
					}
				],
				planRows: [{
						group: '新生',
						phase: '前期筹备',
						time: '报到前1周–后3天',
						work: '方案、账号、培训、宣讲',
						dept: '心理中心、学院'
					},
					{
						group: '新生',
						phase: '集中测评',
						time: '报到后3–7天',
						work: '班级集中线上作答',
						dept: '学院、心理中心'
					},
					{
						group: '新生',
						phase: '补测复核',
						time: '报到后7–10天',
						work: '补测、数据核查',
						dept: '心理中心、学院'
					},
					{
						group: '新生',
						phase: '建档干预',
						time: '筛查后–入学1个月',
						work: '分级、建档、干预、回访',
						dept: '心理中心、学院'
					},
					{
						group: '非新生',
						phase: '通知动员',
						time: '9月上旬',
						work: '发布通知、班会动员',
						dept: '学工处、学院'
					},
					{
						group: '非新生',
						phase: '测评核查',
						time: '9月中–10月上',
						work: '自主测评、补测',
						dept: '心理中心、学院'
					}
				]
			}
		},
		mounted() {
			this.scrollToHashTarget()
		},
		watch: {
			'$route.hash'() {
				this.scrollToHashTarget()
			}
		},
		methods: {
			scrollToHashTarget() {
				if (!this.$route.hash) {
					return
				}
				this.$nextTick(() => {
					const target = document.querySelector(this.$route.hash)
					if (target) {
						target.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.card-box {
		display: flex;
	}

	.university-evaluation-page {
		min-height: 100vh;
		background: #f9fafb;
		color: #1d2939;
	}

	.uni-main {
		padding-top: 64px;
	}

	.section-py {
		padding: 64px 0;
	}

	.section-soft {
		background: #f3f7fc;
	}

	.container-custom {
		max-width: 1260px;
		margin: 0 auto;
		padding: 0 20px;
	}

	.section-head {
		max-width: 780px;
		margin: 0 auto 40px;
		text-align: center;
	}

	.section-head h2 {
		margin: 0;
		font-size: clamp(26px, 3.5vw, 42px);
		line-height: 1.3;
	}

	.section-head p {
		margin: 0;
		font-size: 17px;
		line-height: 1.75;
		color: #5f6f82;
	}

	.title-underline {
		width: 66px;
		height: 5px;
		margin: 18px auto;
		border-radius: 999px;
		background: #36b37e;
	}

	.section-kicker {
		display: inline-block;
		padding: 6px 12px;
		margin-bottom: 10px;
		border-radius: 999px;
		font-size: 12px;
		font-weight: 700;
		letter-spacing: 0.06em;
		text-transform: uppercase;
		color: #1e65c1;
		background: rgba(30, 101, 193, 0.1);
		border: 1px solid rgba(30, 101, 193, 0.2);
	}

	.hero-section {
		background: linear-gradient(135deg, rgba(30, 101, 193, 0.07) 0%, rgba(54, 179, 126, 0.07) 100%);
	}

	.hero-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 30px;
		align-items: center;
	}

	.hero-badge {
		display: inline-block;
		padding: 8px 14px;
		margin-bottom: 10px;
		border-radius: 999px;
		font-size: 13px;
		color: #1e65c1;
		background: rgba(30, 101, 193, 0.1);
	}

	.hero-section h1 {
		margin: 0 0 14px;
		font-size: clamp(34px, 5vw, 56px);
		line-height: 1.25;
	}

	.hero-tagline {
		margin: 0 0 12px;
		font-size: 18px;
		font-weight: 600;
		color: #1e65c1;
	}

	.hero-meta {
		margin: 0;
		font-size: 16px;
		line-height: 1.8;
		color: #4b5563;
	}

	.hero-date {
		color: #5f6f82;
	}

	.hero-image-wrap {
		background: #fff;
		padding: 10px;
		border-radius: 16px;
		border: 1px solid #dbe5f0;
		box-shadow: 0 12px 28px rgba(30, 101, 193, 0.15);
	}

	.hero-image-wrap img {
		display: block;
		width: 100%;
		height: auto;
		border-radius: 10px;
	}

	.toc-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 14px;
	}

	.toc-card {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 16px 18px;
		background: #fff;
		border: 1px solid #deebf8;
		border-radius: 14px;
		box-shadow: 0 3px 15px rgba(30, 101, 193, 0.08);
		text-decoration: none;
		color: inherit;
		transition: all 0.35s ease;
	}

	.toc-card:hover {
		transform: translateY(-4px);
		box-shadow: 0 8px 25px rgba(30, 101, 193, 0.16);
	}

	.toc-num {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: #1e65c1;
		color: #fff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 13px;
		font-weight: 700;
		flex-shrink: 0;
	}

	.toc-title {
		font-size: 15px;
		font-weight: 600;
		color: #1d2939;
	}

	.two-grid,
	.three-grid {
		display: grid;
		gap: 18px;
	}

	.two-grid {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.three-grid {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	.card {
		background: #fff;
		border: 1px solid #deebf8;
		border-radius: 14px;
		padding: 22px 18px;
		box-shadow: 0 3px 15px rgba(30, 101, 193, 0.08);
	}

	.card-hover {
		transition: all 0.35s ease;
	}

	.card-hover:hover {
		transform: translateY(-6px);
		box-shadow: 0 8px 25px rgba(30, 101, 193, 0.16);
	}

	.gradient-text {
		margin: 0 0 14px;
		font-size: 22px;
		background: linear-gradient(90deg, #1e65c1, #36b37e);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		color: transparent;
	}

	.title-badge {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 28px;
		margin-right: 8px;
		border-radius: 50%;
		font-size: 12px;
		font-weight: 700;
		color: #fff;
		background: linear-gradient(135deg, #1e65c1, #36b37e);
	}

	.lead {
		margin: 0 0 12px;
		font-size: 16px;
		font-weight: 600;
		color: #1d2939;
	}

	.desc-list {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.desc-list li {
		position: relative;
		padding-left: 12px;
		font-size: 14px;
		line-height: 1.75;
		color: #5f6f82;
		margin-bottom: 10px;
	}

	.desc-list li::before {
		content: '•';
		position: absolute;
		left: 0;
		color: #1e65c1;
	}

	.desc-list.compact li {
		margin-bottom: 8px;
	}

	.soft-glow {
		background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(249, 252, 255, 1) 100%);
	}

	.highlight-card {
		padding: 20px;
	}

	.goal-grid-lite {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
	}

	.goal-mini {
		padding: 14px;
		border-radius: 12px;
		border: 1px solid #e1eaf5;
		background: #fff;
	}

	.goal-mini-title {
		display: inline-block;
		margin-bottom: 8px;
		padding: 4px 10px;
		border-radius: 999px;
		font-size: 12px;
		font-weight: 700;
		color: #1e65c1;
		background: rgba(30, 101, 193, 0.1);
	}

	.goal-mini p {
		margin: 0;
		font-size: 14px;
		line-height: 1.65;
		color: #5f6f82;
	}

	.responsibility-pills {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.pill-item {
		width: calc(50% - 5px);
		padding: 10px 12px;
		font-size: 13px;
		line-height: 1.65;
		color: #374151;
		border-radius: 10px;
		border: 1px solid #dbe8f6;
		background: #f8fbff;
	}

	.bullet-list {
		margin: 0;
		padding: 18px 22px 18px 36px;
		list-style: none;
	}

	.bullet-list li {
		position: relative;
		font-size: 15px;
		line-height: 1.75;
		color: #374151;
		margin-bottom: 10px;
	}

	.bullet-list li::before {
		content: '•';
		position: absolute;
		left: -14px;
		color: #1e65c1;
		font-weight: bold;
	}

	.stack-item {
		margin-bottom: 14px;
		padding-left: 12px;
		border-left: 4px solid #1e65c1;
	}

	.stack-item h4 {
		margin: 0;
		font-size: 17px;
	}

	.stack-item p {
		margin: 4px 0 0;
		font-size: 14px;
		line-height: 1.7;
		color: #5f6f82;
	}
	
	.exec-card p {
		margin: 0 0 8px;
		font-size: 14px;
		line-height: 1.7;
		color: #5f6f82;
	
	}
	.card-right{
		margin-left: 20px;
	}

	.exec-duty {
		margin-top: 12px !important;
	}

	.tool-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 16px;
	}

	.tool-card h4 {
		margin: 0 0 8px;
		font-size: 17px;
		color: #1d2939;
	}

	.tool-card p {
		margin: 0;
		font-size: 14px;
		line-height: 1.7;
		color: #5f6f82;
	}

	.level-grid {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 14px;
	}

	.level-card {
		padding: 18px 14px;
		border-radius: 14px;
		border: 1px solid #deebf8;
		background: #fff;
	}

	.level-card h4 {
		margin: 0 0 8px;
		font-size: 15px;
	}

	.level-card p {
		margin: 0;
		font-size: 13px;
		line-height: 1.65;
		color: #5f6f82;
	}

	.level-red {
		border-left: 4px solid #e53935;
	}

	.level-yellow {
		border-left: 4px solid #fbc02d;
	}

	.level-blue {
		border-left: 4px solid #1e65c1;
	}

	.level-green {
		border-left: 4px solid #36b37e;
	}

	.border-green {
		border-left: 4px solid #36b37e;
	}

	.border-blue {
		border-left: 4px solid #1e65c1;
	}

	.border-yellow {
		border-left: 4px solid #fbc02d;
	}

	.border-red {
		border-left: 4px solid #e53935;
	}

	.phase-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.phase-item {
		display: flex;
		gap: 10px;
		align-items: flex-start;
		padding-bottom: 12px;
		border-bottom: 1px solid #eef2f7;
	}

	.phase-item:last-child {
		border-bottom: none;
		padding-bottom: 0;
	}

	.phase-item span {
		width: 28px;
		height: 28px;
		border-radius: 50%;
		background: #1e65c1;
		color: #fff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 700;
		flex-shrink: 0;
	}

	.phase-item h4 {
		margin: 0 0 4px;
		font-size: 17px;
	}

	.phase-item p {
		margin: 0;
		font-size: 14px;
		line-height: 1.65;
		color: #5f6f82;
	}

	.number-plain {
		margin: 0;
		padding: 18px 22px;
		list-style: none;
		counter-reset: em;
	}

	.number-plain li {
		position: relative;
		padding-left: 28px;
		margin-bottom: 12px;
		font-size: 15px;
		line-height: 1.75;
		color: #374151;
		counter-increment: em;
	}

	.number-plain li::before {
		content: counter(em, decimal-leading-zero);
		position: absolute;
		left: 0;
		top: 0;
		width: 22px;
		font-size: 13px;
		font-weight: 700;
		color: #1e65c1;
	}

	.table-wrap {
		overflow-x: auto;
		padding: 0;
	}

	.plan-table {
		width: 100%;
		min-width: 720px;
		border-collapse: collapse;
		font-size: 14px;
	}

	.plan-table th,
	.plan-table td {
		padding: 12px 14px;
		text-align: left;
		border-bottom: 1px solid #e8eef5;
		vertical-align: top;
	}

	.plan-table th {
		background: #f0f6fc;
		color: #1d2939;
		font-weight: 600;
		white-space: nowrap;
	}

	.plan-table tbody tr:hover {
		background: #fafcfe;
	}

	.closing-section {
		padding: 72px 0;
		background: linear-gradient(90deg, #1e65c1 0%, #36b37e 100%);
		text-align: center;
		color: #fff;
	}

	.closing-inner h2 {
		margin: 0 0 12px;
		font-size: clamp(28px, 4vw, 40px);
	}

	.closing-inner>p {
		margin: 0 0 24px;
		font-size: 17px;
		opacity: 0.95;
	}

	.closing-tags {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: 12px;
	}

	.closing-tags span {
		padding: 8px 18px;
		border-radius: 999px;
		background: rgba(255, 255, 255, 0.18);
		border: 1px solid rgba(255, 255, 255, 0.35);
		font-size: 14px;
		font-weight: 600;
	}

	.fade-in {
		animation: fadeIn 0.8s ease-in-out forwards;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@media (max-width: 992px) {
		.uni-main {
			padding-top: 56px;
		}

		.section-py {
			padding: 48px 0;
		}

		.hero-grid,
		.two-grid,
		.three-grid,
		.toc-grid,
		.tool-grid,
		.level-grid,
		.goal-grid-lite {
			grid-template-columns: 1fr;
		}

		.pill-item {
			width: 100%;
		}
	}

	@media (max-width: 768px) {
		.card-right{
			margin-left: 0;
			margin-top: 20px;
		}
		.card-box {
			/* display: none; */
			display: block;
		}

		.container-custom {
			padding: 0 14px;
		}

		.section-py {
			padding: 34px 0;
		}

		.section-head p {
			font-size: 14px;
		}
	}
</style>